import React from 'react'
import styled from 'styled-components'
import arrow from '../../../img/right_arrow_broken_darker.png'
import H2 from '../../commons/H2'

const Pluses = () => {
  return (
    <Container>
      <StagesContainer>
        <Stage>
          <StyledH2>Tasso fisso e rate</StyledH2>
          <StyledH2>predeterminate</StyledH2>
        </Stage>
        <Img src={arrow} alt={"Freccia verso destra"}/>
        <Stage>
          <StyledH2>Non vincolato ad uno</StyledH2>
          <StyledH2>specifico acquisto</StyledH2>
        </Stage>
        <Img src={arrow} alt={"Freccia verso destra"}/>
        <Stage>
          <StyledH2>Gestibile anche</StyledH2>
          <StyledH2>totalmente a distanza</StyledH2>
        </Stage>
      </StagesContainer>
    </Container>
  )
}

// region Style
const Container = styled.div`
  max-width: 1125px;
  margin: 6rem auto 6rem auto;
  padding: 0 15px;
`
const StagesContainer = styled.div`
  @media (max-width: 480px) {
    flex-direction: column;
  }
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
const Stage = styled.div`
  width: 100%;
  background-color: white;
  color: #f29505;
  //color: linear-gradient(169deg, #f3b706 0%, #f29505 100%);
  border-radius: 10px;
  padding: 1rem 1rem;
`
const Img = styled.img`
  @media (max-width: 480px) {
    transform: rotate(90deg);
  }
  width: 5rem;
`
const StyledH2 = styled(H2)`
  color: #222;
  margin: unset;
`
// endregion

export default Pluses
